import styled from 'styled-components';

export const AuthorAndTime = styled.div.attrs({
  className: 'AuthorAndTime',
  // family: props => props.fontFamily,
  size: props => props.fontSize,
  weight: props => props.fontWeight,
  color: props => props.color,
  lineheight: props => props.lineHeight,
  padding: props => props.padding || '0.5rem 0.5rem 0 0'
})`
  /* font-family: ${props => props.family}; */
  font-family: 'Montserrat';
  font-size: ${props => props.size};
  /* font-weight: ${props => props.weight}; */
  font-weight: normal;
  color: ${props => props.color};
  padding: ${props => props.padding};
  line-height: ${props => props.lineheight};
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    color: ${props => props.color};
  }
`;
